import authService from '../api-authorization/AuthorizeService'
export default class General {
    async getUsuario() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/Usuarios', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    }
}